// Acar Sanat wordmark. The source PNG is red on white. In dark mode we
// invert it to read on the warm-black canvas; in light mode we leave it
// untouched so the brand crimson reads on cream.

type Props = {
  className?: string;
  height?: number;
};

export function Brand({ className, height = 28 }: Props) {
  return (
    <div className={className} aria-label="Acar Sanat">
      <img
        src="/brand/acarsanat.png"
        alt="Acar Sanat"
        style={{ height, width: 'auto', display: 'block' }}
        className="brand-wordmark"
      />
    </div>
  );
}
